<template>
  <el-form
    v-show="!_.isEmpty(groups)"
    :rules="formUtil.rules"
    ref="formGroup"
    :model="form"
    :validate-on-rule-change="false"
    label-position="left"
    :label-width="widthLevel == '1' ? '127px' : '92px'"
    class="form-group"
  >
    <div v-for="(group, idx) in displayGroups" :key="idx" class="form-group-wrapper">
      <div v-if="!hideTitle" class="title">{{ group.name }}</div>
      <div class="form-group-items">
        <template v-if="idx == 0 && !!projectName">
          <el-form-item
            :class="'form-item-' + widthLevel"
            disabled
            :style="widthLevel == '2' ? 'padding-right:' + paddingRight + 'px' : ''"
            label="项目"
          >
            <el-input
              class="custom-form-item project-name-item"
              disabled
              :value="projectName"
            ></el-input>
          </el-form-item>
        </template>
        <el-form-item
          v-for="control in group.controls"
          :key="control._cid"
          :prop="control._cid"
          :class="'form-item-' + widthLevel"
          :style="widthLevel == '2' ? 'padding-right:' + paddingRight + 'px' : ''"
        >
          <template slot="label">
            <span v-if="requiredFieldCids.includes(control._cid)" class="require-flag">*</span>
            {{ control.name }}
            <!-- 控件提示 -->
            <el-tooltip
              v-if="control.description"
              :content="control.description"
              placement="bottom"
            >
              <span class="icon-tip pointer">
                <i class="el-icon-info"></i>
              </span>
            </el-tooltip>
          </template>
          <custom-form-item
            ref="custom-form-item"
            :form="form"
            type="form"
            v-bind="$attrs"
            :control="control"
            editable
            :allControlMap="formUtil.allControlMap"
            class="custom-form-item"
            @change="output(control, $event)"
            @refDataCreated="$emit('refDataCreated')"
          ></custom-form-item>
        </el-form-item>
      </div>
    </div>
  </el-form>
</template>

<script>
import CustomFormItem from "@/components/Sheet/SheetForm/FormItem"
import { uploadingCounter } from "@/utils/uploadFile"
export default {
  name: "form-group",
  components: {
    CustomFormItem
  },
  props: {
    groups: Array,
    onlyRequired: Boolean,
    hideTitle: Boolean,
    projectName: String,
    widthLevel: {
      type: String,
      default: "1"
    },
    formUtil: Object
  },
  inject: ["status"],
  data() {
    return {
      form: {},
      clientWidth: 0
    }
  },
  computed: {
    allControls() {
      return this.groups?.flatMap(group => group.controls) || []
    },
    requiredFieldCids() {
      if (!this.allControls.length) return []
      return this.allControls.filter(c => c.required && c._type !== "sn").map(c => c._cid)
    },
    displayGroups() {
      return (this.groups || [])
        .map(group =>
          Object.assign({}, group, {
            controls: group.controls.filter(
              control =>
                control.display &&
                (!this.onlyRequired || control.required) &&
                control._type !== "chart"
            )
          })
        )
        .filter(group => group.controls.length)
    },
    currentCids() {
      return this.displayGroups.flatMap(group => group.controls).map(c => c._cid)
    },
    paddingRight() {
      let width = 32
      if (this.clientWidth / 330 >= 4) width = (this.clientWidth - 316 * 4) / 4
      else if (this.clientWidth / 330 >= 3) width = (this.clientWidth - 316 * 3) / 3
      else width = (this.clientWidth - 316 * 2) / 2
      return width
    }
  },
  mounted() {
    let elementResizeDetectorMaker = require("element-resize-detector")
    let erd = elementResizeDetectorMaker()
    erd.listenTo(this.$refs.formGroup.$el, () => {
      this.clientWidth = this.$refs.formGroup.$el.clientWidth
    })
  },
  watch: {
    clientWidth: {
      handler() {
        this.$emit("widthLevelChange", this.clientWidth + 180 < 1100)
      }
    }
  },
  methods: {
    init(form, needUpdateFields) {
      this.form = Object.assign({}, form)
      if (!needUpdateFields) {
        // 初始化
        this.$refs["custom-form-item"]?.forEach(component => {
          component.init(this.form[component.control._cid])
        })
      } else {
        // 更新
        needUpdateFields = needUpdateFields.filter(cid => this.currentCids.includes(cid))
        if (!this.status.initial && needUpdateFields.length) {
          // 校验
          this.$nextTick(() => this.$refs.formGroup?.validateField(needUpdateFields))
        }
        this.$refs["custom-form-item"]
          ?.filter(component => needUpdateFields.includes(component.control._cid))
          .forEach(component => {
            component.init(this.form[component.control._cid])
          })
      }
    },
    output(control, newVal) {
      this.$set(this.form, control._cid, newVal)
      this.$refs.formGroup?.validateField([control._cid])
      this.$emit("update", control._cid, newVal)
    },
    validate() {
      return new Promise((resolve, reject) => {
        if (uploadingCounter > 0) {
          resolve(false)
          this.$message.error("当前还有文件未上传完成,请等待上传完成后重试")
          return
        }
        this.$refs.formGroup.validate(valid => {
          if (!valid) resolve(false)
          resolve(true)
        })
      })
    }
  }
}
</script>

<style lang="scss" scoped>
.form-group {
  .form-group-wrapper {
    .title {
      position: relative;
      margin-bottom: 20px;
      color: $color-font-first;
      font-size: $font-size-title-topic;
      line-height: 28px;
      &::before {
        content: "";
        position: absolute;
        left: -22px;
        width: 6px;
        height: 28px;
        border-radius: 4px;
        background-color: $color-main;
      }
    }
    .project-name-item{
      ::v-deep {
        .el-input__inner {
          color: #303133;
        }
      }
    }
    .form-group-items {
      display: flex;
      flex-wrap: wrap;
      align-content: flex-start;
      margin-bottom: 24px;
      .form-item-1 {
        position: relative;
        margin-bottom: 8px;
        font-size: 14px;
        &:nth-child(odd) {
          width: 51%;
        }
        &:nth-child(even) {
          width: 49%;
          box-sizing: border-box;
        }

        ::v-deep {
          .el-form-item__label {
            min-height: 32px;
            display: flex;
            align-items: center;
            line-height: 18px;
            padding: 0;
            padding-right: 12px;
          }
          .el-form-item__content {
            width: 320px;
            .el-input__suffix .el-icon-circle-check {
              display: none;
            }
          }
          .el-form-item__error {
            position: relative;
          }
        }
      }
      .form-item-2 {
        position: relative;
        margin-bottom: 8px;
        font-size: 14px;
        ::v-deep {
          .el-form-item__label {
            min-height: 32px;
            display: flex;
            align-items: center;
            line-height: 18px;
            padding: 0;
            padding-right: 6px;
          }
          .el-form-item__content {
            width: 214px;
            .el-input__suffix .el-icon-circle-check {
              display: none;
            }
          }
          .el-form-item__error {
            position: relative;
          }
        }
      }
      .require-flag {
        color: red;
        font-size: 24px;
        padding-right: 4px;
        padding-top: 10px;
      }
      .icon-tip {
        margin-left: 4px;
        font-size: 16px;
        &:hover {
          color: #3aacf8;
        }
      }
    }
  }
}
</style>
